/**
 * Animation timing constants for CopilotBarLoading component
 * Centralized to ensure synchronization between JS logic and CSS transitions
 */

// Duration of the phrase slide animation (must match CSS transition)
export const ANIMATION_DURATION = 500; // milliseconds

// Brief delay before sliding "Done!" message to center position
export const DONE_CENTER_DELAY = 600; // milliseconds
